







































































































































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import InfiniteLoading from "vue-infinite-loading";
import TextDayChangePicker from "@/components/common/TextDayChangePicker.vue";
import TimePicker from "@/components/common/TimePicker.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import { dateJp } from "@/types";

@Component({
  components: {
    InfiniteLoading,
    TextDayChangePicker,
    TimePicker,
    LoadingDialog
  }
})
export default class OperationLog extends mixins(AxiosMixin) {
  @Ref("infiniteLoading") private readonly infiniteLoading!: InfiniteLoading;

  private headers = [
    { text: "実行日時", value: "timestamp_disp", sortable: false },
    { text: "実行職員", value: "office_staff_name", sortable: false },
    { text: "機能名", value: "exec_name", sortable: false },
    { text: "状態", value: "status_name", sortable: false },
    { text: "内容", value: "content", sortable: false },
    { text: "IPアドレス", value: "ip", sortable: false },
    { text: "OS", value: "os", sortable: false },
    { text: "ブラウザ", value: "browser", sortable: false }
  ];

  start_date = dateJp(new Date()).substr(0, 10);
  start_time_hh = "00";
  start_time_mm = "00";

  end_date = dateJp(new Date()).substr(0, 10);
  end_time_hh = "23";
  end_time_mm = "59";

  private minDate = "2026-06-01";

  private get isBeforeMinDate(): boolean {
    return this.start_date < this.minDate || this.end_date < this.minDate;
  }

  office_id: number | null = null;
  staff_id: number | null = null;
  patient_id: number | null = null;
  path = "";
  exclude_get_operations = true;

  private logs: any[] = [];
  private next_timestamp: any = null;
  private firstSearch = false;

  actions: any[] = [];
  offices: any[] = [];
  staffs: any[] = [];
  patients: any[] = [];

  mounted() {
    this.postJsonCheck(window.base_url + "/api/userinfo/get", {}, res => {
      if (!res.data.is_receipt_opelog_enabled) {
        this.$router.replace("/");
        return;
      }
      this.getMaster();
      this.search();
    });
  }

  /** マスタ取得 */
  private getMaster() {
    this.postJsonCheck(
      window.base_url + "/api/operationlog/get_master",
      { office_id: this.office_id || 0 },
      res => {
        this.actions = res.data.actions;
        this.offices = res.data.offices;
        this.staffs = res.data.staffs;
        this.patients = res.data.patients;
      }
    );
  }

  /** 事業所変更時 */
  private onChangeOffice() {
    this.staff_id = null;
    this.patient_id = null;
    this.$nextTick(() => {
      this.getMaster();
    });
  }

  /** 検索処理 */
  private async search() {
    this.logs = [];
    this.firstSearch = true;
    await this.$nextTick();

    this.infiniteLoading.stateChanger.reset();
    this.next_timestamp = null;
  }

  private infiniteHandler() {
    this.updateData();
  }

  /** データ更新 */
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/operationlog/gets",
      {
        start_date:
          this.start_date + " " + this.start_time_hh + ":" + this.start_time_mm,
        end_date:
          this.end_date + " " + this.end_time_hh + ":" + this.end_time_mm,
        office_id: this.office_id || 0,
        staff_id: this.staff_id || 0,
        path: this.path,
        patient_id: this.patient_id || 0,
        timestamp: this.next_timestamp,
        exclude_get_operations: this.exclude_get_operations
      },
      res => {
        this.logs = this.logs.concat(res.data.operation_logs);
        this.next_timestamp = res.data.next_timestamp;
        if (this.infiniteLoading) {
          if (res.data.operation_logs.length > 0) {
            this.infiniteLoading.stateChanger.loaded();
          }
          if (!res.data.next_timestamp) {
            this.infiniteLoading.stateChanger.complete();
          }
        }
      }
    );
  }
}
